import { rootApi } from "..";
import { inventoryProductService } from "../../../Api/Services/InventoryService/inventoryProduct";
import { makeEndpoints } from "../../../utils/rtkQueryFactory";

const endpoints = [{
  name: "getMyAssets",
  type: "query",
  serviceFn: (payload: { userId?: number } | undefined) => payload?.userId
    ? inventoryProductService.getEmployeeAssets(payload.userId)
    : inventoryProductService.getMyAssets(),
}] as const;

const employeeAssetsApi = rootApi.injectEndpoints({
  endpoints: (builder) => makeEndpoints(builder, endpoints),
});

export const { useGetMyAssetsQuery } = employeeAssetsApi;
